import * as React from "react";
import { observer } from "mobx-react";
import { Switch } from "@blueprintjs/core";
import { BootstrapTable, SearchField, TableHeaderColumn } from "react-bootstrap-table";
import { NotificacoesStore } from "../../stores/notificacoes/NotificacoesStore";

@observer
export default class WarningAdmin extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        await NotificacoesStore.handleConsultaModulos();
    }

    createCustomSearchField = (props) => {
        return (
            <SearchField
                className="input-filter input-filter-cron"
                defaultValue={props.defaultSearch}
                placeholder="Filtrar Módulo"
            />
        );
    };

    render() {

        let modulos = NotificacoesStore.obs.modulos?.map(value => {
            return (value);
        });

        const options = {
            searchField: this.createCustomSearchField,
        };

        function buttonFormatter(cell, row) {
            return (
                <div>
                    <Switch
                        label={row.status ? "Disponível" : "Indisponível"}
                        checked={row.status}
                        onChange={(e: any) => NotificacoesStore.changeStatusModulo(row.id, e.target.checked)}
                    />
                </div>
            );
        }

        function moduloFormatter(cell, row) {

          if(!cell) return ""

          return (cell.toUpperCase());

        }

        return (
            <>
                <BootstrapTable className="tabela-cron" ref="table" data={modulos} options={options} search>
                    <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataField="modulo" dataFormat={moduloFormatter} width="70%">Modulo</TableHeaderColumn>
                    <TableHeaderColumn dataField="status" dataFormat={buttonFormatter} width="30%">Disponível</TableHeaderColumn>
                </BootstrapTable>
            </>
        )
    }
}